import { TipPipe } from './../../services/tip.pipe';

import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';


@Component({
  selector: 'app-video-corsi',
  templateUrl: './video-corsi.component.html',
  styleUrls: ['./video-corsi.component.css']
})
export class VideoCorsiComponent implements OnInit {
  selectedValue: any;
  listVideo: any;
  obiettivo: string = "";
  status: boolean = false;
  searchText: string;
  show: boolean = false;
showAll : boolean = false;

  hideFit: boolean = false;
  hidePil: boolean = false;
  hideGinn: boolean = false;
  hidePost: boolean = false;
  hideAnz: boolean = false;
  hideBamb: boolean = false;
  hidePat: boolean = false;


  listObiettivi = [
    { id: 11, text: 'Tutti' },
    { id: 1, text: 'Tonificazione' },
    { id: 2, text: 'Dimagrimento' },
    { id: 3, text: 'Coordinamento' },
    { id: 4, text: 'Stress' },
    { id: 5, text: 'Flessibilità' },
    { id: 6, text: 'Mobilità' },
    { id: 7, text: 'Equilibrio' },
    { id: 8, text: 'Dolori' },
    { id: 9, text: 'Circolazione' },
    { id: 10, text: 'Forza' },

  ];



  constructor(
    private http: HttpClient,
    private router: Router
  ) {

    this.getVideo();
  }

  ngOnInit(): void {
    this.setTip("Tutti", 0)
  }

  getVideo() {
    this.http.get("../../assets/doc/video.json")
      .subscribe(data => {
        this.listVideo = data;
        //console.log(this.listVideo)
      })

  }

  setTip(s: string, i: any) {
    if (s === "Tutti") {
   this.showAll = false
    }else{
      this.showAll = true
    }

    this.obiettivo = s;
    this.selectedValue = s;
    this.show = false;
    //console.log(s, i);
    if (i === 1) {
      this.hideFit = false;
      this.hidePil = false;
      this.hideGinn = false;
      this.hidePost = true;
      this.hideAnz = true;
      this.hideBamb = true;
      this.hidePat = true;
    } else if (i === 2) {
      this.hideFit = false;
      this.hidePil = true;
      this.hideGinn = true;
      this.hidePost = true;
      this.hideAnz = true;
      this.hideBamb = true;
      this.hidePat = false;
    } else if (i === 3) {
      this.hideFit = true;
      this.hidePil = true;
      this.hideGinn = false;
      this.hidePost = true;
      this.hideAnz = false;
      this.hideBamb = false;
      this.hidePat = false;
    } else if (i === 4) {
      this.hideFit = true;
      this.hidePil = true;
      this.hideGinn = false;
      this.hidePost = false;
      this.hideAnz = true;
      this.hideBamb = true;
      this.hidePat = true;
    } else if (i === 5) {
      this.hideFit = true;
      this.hidePil = false;
      this.hideGinn = false;
      this.hidePost = false;
      this.hideAnz = true;
      this.hideBamb = true;
      this.hidePat = true;
    } else if (i === 6) {
      this.hideFit = true;
      this.hidePil = true;
      this.hideGinn = false;
      this.hidePost = true;
      this.hideAnz = true;
      this.hideBamb = false;
      this.hidePat = false;
    } else if (i === 7) {
      this.hideFit = true;
      this.hidePil = true;
      this.hideGinn = true;
      this.hidePost = false;
      this.hideAnz = false;
      this.hideBamb = true;
      this.hidePat = true;
    } else if (i === 8) {
      this.hideFit = true;
      this.hidePil = true;
      this.hideGinn = false;
      this.hidePost = false;
      this.hideAnz = true;
      this.hideBamb = true;
      this.hidePat = true;
    } else if (i === 9) {
      this.hideFit = true;
      this.hidePil = true;
      this.hideGinn = false;
      this.hidePost = false;
      this.hideAnz = true;
      this.hideBamb = true;
      this.hidePat = true;
    } else if (i === 10) {
      this.hideFit = false;
      this.hidePil = true;
      this.hideGinn = false;
      this.hidePost = false;
      this.hideAnz = true;
      this.hideBamb = true;
      this.hidePat = false;
    }else if (i === 0) {
      this.hideFit = false;
      this.hidePil = false;
      this.hideGinn = false;
      this.hidePost = false;
      this.hideAnz = false;
      this.hideBamb = false;
      this.hidePat = false;
    }


  }







}
